import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tela_padrao_crud = _resolveComponent("tela-padrao-crud")!
  const _component_categoria_permissao_modal = _resolveComponent("categoria-permissao-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tela_padrao_crud, {
      estrutura: _ctx.crudBase.estrutura,
      servicoAPI: _ctx.servicoCategoriaPermissao,
      onExibirModal: _ctx.exibirModal,
      onSincronizaTelaCrud: _ctx.sincronizaTelaCrud
    }, null, 8, ["estrutura", "servicoAPI", "onExibirModal", "onSincronizaTelaCrud"]),
    _createVNode(_component_categoria_permissao_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.crudBase.operacao) = $event))
    }, null, 8, ["visivel", "operacao"])
  ], 64))
}